export default function About(props) {

    const { datas } = props;

    return (
        <div className="p-relative">
            <div style={{ height: "40vh", overflow: "hidden" }}>
                <div className=""
                    style={{
                        backgroundImage: `url(${"/images/about/about.jpg"})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        opacity: .7,
                        height: "100%",
                    }}>
                </div>
                <div className="p-absolute w-100" style={{ top: "0%" }}>
                    <div className="container pt-xl-5 pt-3">
                        <div className="row">
                            <div className="col-md-5">
                                <div className="overflow-hidden my-3">
                                    <h1 className="line-height-4 text-primary font-weight-bold text-12 mb-0">
                                        DEF24 Inc.
                                    </h1>
                                    <p className="text-6 text-dark font-weight-bold line-height-3">
                                        {datas.photoParag} </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="container">
                <div className="row text-left">
                    <div className="col-md-12">

                        <div className="my-lg-5 my-2">
                            <p className="text-5 mb-0 line-height-3 text-dark">
                                {datas.definitionOne}
                                <span className="font-weight-bold "> {datas.definitionTwo} </span>
                                {datas.definitionThree}
                                <span className="font-weight-bold"> {datas.definitionFour} </span>
                                {datas.definitionFive}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row py-md-3 py-2">
                    <div className="col">
                        <div className="row mb-md-2 mb-1">
                            <div className="col-md-4">
                                <h3 className="font-weight-bold line-height-4 text-secondary text-6 mb-2">{datas.visionTitle}</h3>
                                <p className="text-5 line-height-3 text-dark"> {datas.visionPar} </p>
                            </div>
                            <div className="col-md-4">
                                <h3 className="font-weight-bold line-height-4 text-secondary text-6 mb-2"> {datas.missionTitle} </h3>
                                <p className="text-5 line-height-3 text-dark"> {datas.missionPar} </p>
                            </div>
                            <div className="col-md-4">
                                <h3 className="font-weight-bold line-height-4 text-secondary text-6 mb-2"> {datas.whyUsTitle} </h3>
                                <p className="text-5 line-height-3 text-dark"> {datas.whyUsPar} </p>
                            </div>
                        </div>
                        <div className="row mt-lg-3 mb-3">
                            <div className="col">
                                <h3 className="font-weight-bold line-height-4 text-secondary text-6 mb-2">{datas.humanResources.title}</h3>
                                <p className="text-5 line-height-2 text-dark">
                                    {datas.humanResources.definitionOne}
                                    <a> {datas.humanResources.mail} </a> {datas.humanResources.definitionTwo}
                                </p>
                                <p className="mb-3 text-5 line-height-3 text-dark"> {datas.humanResources.definitionThree}</p>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    )
}

